(function() {

    'use strict';

    eclipseApp.factory('prepaidRefillAutoBalanceService', function() {

        var thresholdValue = null;
        var refillValue = null ;

        function setThresholdValue(data) {
            thresholdValue = data;
        }

        function getThresholdValue() {
            return thresholdValue;
        }

        function setRefillValue(data) {
            refillValue = data;
        }

        function getRefillValue() {
            return refillValue;
        }

        return {
            setThresholdValue: setThresholdValue,
            getThresholdValue: getThresholdValue,
            setRefillValue: setRefillValue,
            getRefillValue: getRefillValue,
        };

    });

})();
